export enum FutureFlag {
  MAKE_WINNER_BUTTON = 'makeWinnerButton', // 06/03/2026
  PRICE_TESTING = 'priceTesting', // --
  LANGUAGE_SETTING = 'languageSetting', // --
  FILTER_BY_SHOPIFY_PAGE_ID = 'filterByShopifyPageId', // --
  DEV_MODE = 'devMode', // 21/10/2025
  PRICING_COUPON = 'pricingCoupon', // 23/10/2025
  HOTFIX_TEMPLATE_LOADING = 'hotfixTemplateLoading', // 14/04/2026
  AFTER_MAKE_WINNER = 'afterMakeWinner', // 27/02/2026
  HEATMAP_MOCK_DATA = 'heatmapMockData', // 27/02/2026
  HEATMAP_BETA = 'heatmapBeta', // 02/02/2026
  HEATMAP_V1 = 'heatmapV1', // 24/03/2026
  HEATMAP_V2 = 'heatmapV2', // 24/03/2026
  HEATMAP_V3 = 'heatmapV3', // 12/06/2026
}
export type IFutureFlag = Record<FutureFlag, boolean>;
